import type { MailboxInfo } from 'owa-client-types';
import { action } from 'satcheljs';

export interface OnDismissLeftNavBarActionMessage {
    mailboxInfo: MailboxInfo;
    isMSQ: boolean;
}
export const onDismissLeftNavBar: (
    mailboxInfo: MailboxInfo,
    isMSQ: boolean
) => OnDismissLeftNavBarActionMessage = action(
    'onDismissLeftNavBar',
    (mailboxInfo: MailboxInfo, isMSQ: boolean): OnDismissLeftNavBarActionMessage => ({
        mailboxInfo,
        isMSQ,
    })
);
